export enum ZbsInvoiceCreation
{
	UNDEFINED = 'UNDEFINED',
	CHOICE_DFLT_YES = 'CHOICE_DFLT_YES',
	CHOICE_DFLT_NO = 'CHOICE_DFLT_NO',
	NO = 'NO',
	YES = 'YES'
}